import React, { Component } from "react";
import { object } from 'prop-types';
import { connect } from "react-redux";
import * as _ from 'lodash';

const CheckAccountCredsHOC = ComposedComponent => {

    class Auth extends Component {
  		static contextTypes = {
  		  router: object
  	 	}

      componentWillMount() {

        window.onbeforeunload = function(e){
            e.preventDefault();
            return "Reloading will log you out.";
        };


  		 if (!this.props.isValidAccountCreds) {
  			 this.context.router.history.push('/');
  		 }
  	 }

  	 componentWillUpdate(nextProps) {
  		 if (!nextProps.isValidAccountCreds) {
             this.context.router.history.push('/');
         }
  	 }



	 render() {
         if(!this.props.isValidAccountCreds){
             window.onbeforeunload = null;
             //HACK: IE HACK
             setTimeout( window.location.reload(), 100);
         }
		   return <ComposedComponent {...this.props} />
	   }
	}

	const mapStateToProps = state => {
    return {
			//valid accounts from state indicate proper creds input.
			isValidAccountCreds: (_.isEmpty(state.accounts)) ? false : true,
            isAccountPaid: state.ui.accountPaid
		  }
    }

    return connect(mapStateToProps)(Auth);
}

export default CheckAccountCredsHOC;



// WEBPACK FOOTER //
// ./src/components/HOC/checkAccountCredsHOC.js